export enum TemplatesQueries {
	GET_ASPECT_RATIOS = `
    query AspectRatios($companyId: Int!) {
        aspectRatios(
        companyId: $companyId,
        where: { active: { eq: true } }) {
            nodes {
                id
                code
                description
            }
        }
    }
    `,
	GET_MEDIA_FORMATS = `
    query MediaFormats($companyId: Int!) {
        mediaFormats(
        companyId: $companyId,
        where: { active: { eq: true } }) {
            nodes {
                id
                code
                description
            }
        }
    }
    `,
	GET_CODIFIED_USEDS = `
    query CodifiedUseds($companyId: Int!, $search: String) {
        codifiedUseds(
            companyId: $companyId,
            where: {
                active: { eq: true }
                or: [{ code: { contains: $search } }, { description: { contains: $search } }]
            }
        ) {
            nodes {
                id
                code
                description
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
	GET_CODIFIED_USEDS_BY_IDS = `
    query CodifiedUseds($companyId: Int!, $ids: [Int!]!) {
        codifiedUseds(
            companyId: $companyId,
            where: {
                active: { eq: true }
                id: { in: $ids }
            }
        ) {
            nodes {
                id
                code
                description
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
    GET_SHOT_TYPES = `
    query ShotTypes($companyId: Int!, $first: Int, $after: String, $search: String) {
        shotTypes(companyId: $companyId, first: $first, after: $after, order: {code: ASC}
        where: {             
                or: [
                    { code: { contains: $search } }
                    { name: { contains: $search } }
                ]
            }
        ) {
            nodes {
                id
                code
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
    GET_SHOT_COMBINATIONS = `
    query ShotCombinations($companyId: Int!, $mediaFormatId: Int!, $aspectRatioId: Int!) {
        shotCombinations(
            companyId: $companyId
            where: { active: { eq: true }, mediaFormatId: { eq: $mediaFormatId }, aspectRatioId: { eq: $aspectRatioId } }
        ) {
            nodes {
                id
                mediaFormatId
                codifiedUsedId
                aspectRatioId
                active
            }
        }
    }
    `,
    GET_CATEGORY_STYLE = `
    query CategoryStyle($brandId: Int!, $categoryId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $companyId: Int!) {
        categoryStyle(
            brandId: $brandId
            categoryId: $categoryId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            companyId: $companyId
        ) {
            nodes {
                modelId
                styleCode
                styleName
                fullName
                sketchImgPath
            }
        }
    }
    `,

	GET_TEMPLATES = `
    query Templates($companyId: Int!, $paginationPage: Int!, $paginationSize: Int!, $brandIds: [Int!]!, $categoryIds: [Int!]!) {
        templates(
            companyId: $companyId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            brandIds: $brandIds
            categoryIds: $categoryIds
        ) {
            nodes {
                templateId
                templateName
                companyId
                brandId
                brandName
                categoryId
                categoryName
                hasSizeGroup
                isDefault
                shotTypes {
                    templateId
                    sizeGroupName
                    sizeGroupId
                    shotTypeId
                    shotTypeCode
                    shotTypeName
                    ord
                    aspectRatioId
                    mediaFormatId
                    codifiedUsedId
                }
                styles {
                    templateId
                    modelId
                    styleCode
                    styleName
                    fullName
                    sketchImgPath
                }
                colors {
                    templateId
                    colorId
                    colorCode
                    colorName
                    fullName
                }
            }
        }
    }
    `,
	GET_TEMPLATE_BY_ID = `
    query TemplateById($templateId: Int!, $companyId: Int!) {
        templateById(templateId: $templateId, companyId: $companyId) {
            nodes {
                templateId
                templateName
                companyId
                brandId
                brandName
                categoryId
                categoryName
                hasSizeGroup
                colors {
                    templateId
                    colorId
                    colorCode
                    colorName
                    fullName
                }
                styles {
                    templateId
                    modelId
                    styleCode
                    styleName
                    fullName
                    sketchImgPath
                }
                shotTypes {
                    templateId
                    sizeGroupName
                    sizeGroupId
                    shotTypeId
                    shotTypeCode
                    shotTypeName
                    ord
                    aspectRatioId
                    mediaFormatId
                    codifiedUsedId
                }
            }
        }
    }
    `,




}

